import { 
	deleteFromObjectByPath, 
	addToObjectByPath, 
	SearchPanel, 
} from 'component-library';
import { StatusRadioButtons  } from '../StatusRadioButtons/StatusRadioButtons.js';
import { useDidUpdateEffect } from 'hooks-library';
import { otherConcept } from '../../functions/otherConcept/otherConcept.js';
import { pluralConcepts } from '../../functions/pluralConcepts/pluralConcepts.js';
import { apiFetchWithErrorCheck } from '../../functions/apiFetchv4/apiFetch.js'; 
import { capitalize } from 'helper-functions-library';
//functions
const { useState, useRef, Children } = wp.element;
import searchPanelStyles from './searchPanelStyles.css';

export function RFSearchPanel(props) { 

	let other = otherConcept(props.concept),
		defaultSearchPanelSettings = {
			searchType: 'basic', //what type of search form
			limit:10,
			page: 1,
			_condition_group:{
				_conditions:[
					{ _condition: {_table: 'rf_'+props.concept, _field:props.concept, _operator_and_value:{_value:'', _operator:'contains'}}	},
				],
				_condition_group_operator:'AND',
			}, 
			orderResultsByChoices: [
				{name: 'Numbering', value: props.concept+'_local_numbering'},
				{name: props.concept, value: props.concept},
				{name: 'Date accepted', value: props.concept+'_date_accepted'},
				{name: 'Date of review', value: props.concept+'_next_review'},
			],
			order_by: props.concept,
			order: 'ASC',
			fieldOptions: [
				{name: capitalize(props.concept), value: props.concept},
				{name: 'Status', value: props.concept+'_status'},
				{name: 'Numbering', value: props.concept+'_local_numbering'},
				{name: 'Date accepted', value: props.concept+'_date_accepted'},
				{name: 'Date of review', value: props.concept+'_next_review'},
				{name: 'Authority to change', value: props.concept+'_authority_to_change'},
				{name: 'Additional information', value: props.concept+'_additional_info'},
				{name: 'Category', value: 'category'},
				{name: capitalize(other), value: other},
			],
		},
		operatorConditions = (operators, fieldOption)=>{
			switch (fieldOption) {
				case props.concept:
				case props.concept+'_additional_info':
				case props.concept+'_local_numbering':
				case props.concept+'_authority_to_change':
				case 'category':
				case other:
					return operators['text']; 
					break;
				case props.concept+'_date_accepted':
				case props.concept+'_next_review':
					return operators['dateNumber'];
					break;
				case props.concept+'_status':
					return [{name:'Equal to', value:'='}];
					break;
				default:
					return operators['full'];
			}
		},
		inputConditions = (fieldOption)=>{
			switch (fieldOption) {
				case props.concept+'_date_accepted':
				case props.concept+'_next_review':
					return {inputType:'input', type:'date'};
					break;
				case props.concept+'_status':
					return {inputType:<StatusRadioButtons concept={props.concept}/>};
					break;
				default:
					return {inputType:'input', type:'text'};
			}
		},
		timeoutId = useRef(),
		tableColumn = {},
		searchOptions = true;
		
	if (props.concept == 'category') {
		defaultSearchPanelSettings.orderResultsByChoices = null;
		defaultSearchPanelSettings.fieldOptions = null;
		searchOptions = null;
	}
		
	const [state, setState] = useState(defaultSearchPanelSettings),
		[results, setResults] = useState({}),
		[spinner, setSpinner] = useState(false);
		
	if (props.concept !== 'category') {	
		[
			'rf_'+props.concept+'_framework_relationships',
			'rf_'+props.concept,
			'rf_'+other,
			'rf_category'
		].forEach((table)=>{
			Object.keys(framework_info.tableSettings[table]._table_columns).forEach((column)=>{
				tableColumn[column] = table;
			})
		});
	}
		
		
	//handles updating the search settings, depending on what is change i.e. subject, more changes are made
	function changeSearchSettings(event) {

		let { value, name } = event.target,
			path = event.target.dataset.path ?? name,
			currentState = JSON.parse(JSON.stringify(state)), //deep copy 
			action = event.target?.dataset?.action !== undefined ? event.target.dataset.action: 'add'; //if there is an action use it, or default to add
		
		//if we are changing search types, reset eveything
		if (name == 'searchType') {
			setState({...defaultSearchPanelSettings, [name]:value});
			setResults({}); //remove the results too
			return;
		}
		
		path = path.split('.');
		value = event.target?.dataset?.json !== undefined ? JSON.parse(value): value; //if the value will be json, convert to json, or keep as is
		
		//if we are changing the field we need to change the table too
		if (path[path.length - 1] === '_field') {
			let tablePath = [...path], 
				operatorPath = JSON.parse(JSON.stringify(path)),
				table = tableColumn[value];
			
			tablePath[tablePath.length - 1] = '_table';
			
			addToObjectByPath(currentState, [...tablePath], table);
			
			//also adjust the operator
			operatorPath[operatorPath.length - 1] = '_operator_and_value';
			operatorPath.push('_operator');
			switch (value) {
				case props.concept:
				case props.concept+'_additional_info':
				case props.concept+'_local_numbering':
				case props.concept+'_authority_to_change':
				case 'category':
				case other:
					addToObjectByPath(currentState, operatorPath, 'contains');
					break;
				case props.concept+'_date_accepted':
				case props.concept+'_next_review':
				case props.concept+'_status':
					addToObjectByPath(currentState, operatorPath, '=');
					break;
				default:
					addToObjectByPath(currentState, operatorPath, 'contains');
					break;
			}
		}
	
		//if action is delete, delete, else add
		( action == 'delete') ? deleteFromObjectByPath(currentState, path) : addToObjectByPath(currentState, [...path], value); //changed by reference

		setState(currentState);
	}

	function runSearch() {
		setSpinner(true);//turn on the spinner
		
		let copyOfState = JSON.parse(JSON.stringify(state)),
			query = { 
				_order_by: [
					{
						_table: 'rf_'+props.concept,
						_field: copyOfState.order_by,
						_order: copyOfState.order,
					}
				],
				_limit: parseInt(copyOfState.limit),
				_offset: parseInt((copyOfState.page-1) * copyOfState.limit),
				_condition_group: copyOfState._condition_group,
				_framework_ids:[framework_info.id_framework],
			},
			action = props.action ?? 'get_'+props.concept+'_linked_results'; //default to getting results
		
		//change order by table if these fields are used
		if ([props.concept+'_local_numbering', props.concept+'_date_accepted', props.concept+'_next_review'].includes(query._order_by[0]._field)) {
			query._order_by[0]._table = 'rf_'+props.concept+'_framework_relationships';
		}

		apiFetchWithErrorCheck({ 
			action: action,
			nounce: framework_info.nounce,
			data: query,
		}).then(function(results) { 
			setResults(results); //set the results
			setSpinner(false); //turn the spinner off
		})
		.catch((error) => {
			props.setMessage({message:error.message, messageType:'alert'});
			setSpinner(false);
		});
	}
	
	if (props.trigger) {
		props.setTrigger(false);//turn it back off
		timeoutId.current = setTimeout(() => {
			runSearch();
		}, 100);
		
	}
	
	//check is there is a change in props, if so, reset everything
	useDidUpdateEffect(() => {    
		setState(defaultSearchPanelSettings);
		setResults({});
	}, [props.concept]);
	
	//run seach after settings changed, exclude when doing an advance search
	useDidUpdateEffect(() => {	
		if ( [null,'basic'].includes(state.searchType) ) {
	   		clearTimeout(timeoutId.current);
			timeoutId.current = setTimeout(() => {
				runSearch();
			}, 600);
		}
	}, [state]);
	
	let count = results?.count?.[0],
		data = results?.results?.[0];
	
	return <SearchPanel
		runSearch={runSearch} 
		spinner={spinner} 
		onChange={changeSearchSettings}
		resultsCount={count}
		operatorConditions={operatorConditions}
		inputConditions={inputConditions}
		searchOptions={searchOptions}
		{...state} 
	>
		{ ( count == undefined || data  == undefined ) ? null :
			Children.map(props.children,(Child, index) => {
				let Type = Child.type;
				
				if (Child.props?.['data-results'] !== undefined){
					Child.props.count = count;
					Child.props.data = data;
				}
				
				return <Type 
					{...Child.props}
				/>
			})
		}
	</SearchPanel>;
}